"use strict";
import _ from 'lodash';

export default class EventCommonController
{
	/*@ngInject*/
	constructor($http, $scope, $stateParams, Upload, messageService)  //function ($scope, $stateParams, $log, $http, Upload)
	{
		//console.log("EventCommonController");

		$scope.vm.dateFormats = ['dd-MM-yyyy', 'dd/MM/yyyy'];
		$scope.vm.dateFormat = $scope.vm.dateFormats[0];
		$scope.vm.dateOptions = {
			//'format-day-title': 'dd/MM/yyyy',
			showWeeks: false,
			startingDay: 1
		};
	
		$scope.vm.OpenCalendar = function(element) 
		{
			//$event.preventDefault();
			//$event.stopPropagation();

			$scope.vm[element] = true;
		};

		$scope.vm.DateValidation = function(date)
		{
			return isNaN(Date.parse(date)) !== true;
		}

		$scope.$watch('form.$valid', function(valid, oldvalue)
		{
			if (valid === true)
				$scope.vm.showError = false;
		});

		$scope.$watch("vm.file", function()
		{
			if ($scope.vm.file)
			{
				//console.log("WATCH FILES..." + $scope.file);
				//console.log($scope.file);
				$scope.Upload($scope.vm.file);
			}
		});
			
		$scope.AddRace = function()
		{
			$scope.vm.data.races.push({});
		};

		$scope.RemoveRace = function(index, value)
		{
			$scope.vm.data.races.splice(index, 1);
		};

		$scope.Upload = function(file)
		{
			console.log("Uploading...");
			if (file)
			{
				Upload.upload({
					url: "/api/backend/events/imageupload",
					data: {file: file}
				}).progress(function(evt)
				{
					var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					console.log("progress: " + progressPercentage + "%");
				}).success(function(data, status, headers, config)
				{
					console.log("file " + file + " uploaded. Response: " + data);
					$scope.AddImageToCarrousel(data);
				});
			}
		};
			
		$scope.LoadExternalImage = function()
		{
			if ($scope.vm.externalImage !== "")
			{
				$scope.vm.AddImageToCarrousel($scope.externalImage);
				$scope.vm.externalImage = "";
			}
		};
			
		$scope.AddImageToCarrousel = function(image)
		{
			if (!$scope.vm.data.images) 
				$scope.vm.data.images = [];

			$scope.vm.data.images.push(image);
			$scope.vm.data.selectedImage = $scope.vm.data.images.length - 1;
		};

		function ComposeDate(d, h)
		{
			return new Date(d.getFullYear(), d.getMonth(), d.getDate(), h.getHours(), h.getMinutes(), h.getSeconds(), h.getMilliseconds());
		}

		////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
		$scope.vm.CollectEventData = function(data)
		{
			var ret = {};
			
			ret.selectedclub = data.selectedclub ? data.selectedclub.id : null;
			ret.selectedtrack = data.selectedtrack ? data.selectedtrack.id : null;
			ret.title = data.title;
			ret.price = data.price;

			ret.descriptionhtml = data.descriptionhtml;

			if (!_.isNil(data.selectedImage))
			{
				ret.image = data.images[data.selectedImage];
			}

			ret.races = [];
			if (data.races)
			{
				for (let i = 0; i < data.races.length; ++i)
				{
					let r = data.races[i];
					if (r.category == null)
					{
						messageService.Error("No class selected");
						return;
					}

					ret.races.push({id: r.id, category_id: r.category.id, suffix: r.suffix, maxinscriptions: r.maxinscriptions});
				}
			}
			else
			{
				messageService.Error("No class selected");
				return;
			}
			
			if (data.fromdate !== null) 
			{
				ret.fromdate = ComposeDate(data.fromdate, data.fromdateHours);
				//ret.fromdate = ~~(new Date(ret.fromdate).valueOf() / 1000);
			}

			if (data.todate !== null) 
			{
				ret.todate = ComposeDate(data.todate, data.todateHours);
				//ret.todate = ~~(new Date(ret.todate).valueOf() / 1000);
			}

			if (data.openinscriptions !== null) 
			{
				ret.openinscriptions = ComposeDate(data.openinscriptions, data.openinscriptionsHours);
				//ret.openinscriptions = ~~(new Date(ret.openinscriptions).valueOf() / 1000);
			}

			if (data.closeinscriptions !== null) 
			{
				ret.closeinscriptions = ComposeDate(data.closeinscriptions, data.closeinscriptionsHours);
				//ret.closeinscriptions = ~~(new Date(ret.closeinscriptions).valueOf() / 1000);
			}

			ret.published = data.published || false;
			ret.allownotransponder = data.allownotransponder || false;
			ret.tires = data.tires || false;
			ret.autoconfirmation = data.autoconfirmation || false;

			ret.extraform = data.extraform;
			ret.form2mail = data.form2mail;
			ret.extramail = data.extramail;

			ret.allowremovinginscriptions = data.allowremovinginscriptions;

			return ret;
		};
	}
}



// WEBPACK FOOTER //
// ./client/app/backend/events/event_common.controller.js